import './text-truncate.scss';
import {useEffect, useRef, useState} from "react";
export interface IMaxWidth {
    value: number;
    type: 'ch' | 'px';
}

export interface ITextTruncate{
    maxWidth?: IMaxWidth;
    maxLines?: number;
    children: React.ReactNode;
    allowExpand?: boolean;
    preventDefaultTooltip?: boolean;
}

const TextTruncate: React.FC<ITextTruncate> = ({maxWidth, maxLines = 1, children, allowExpand, preventDefaultTooltip = false}): JSX.Element => {
    const contentRef = useRef<HTMLDivElement>(null);
    const [isClamped, setClamped] = useState(false);
    const [isExpanded, setExpanded] = useState(false);
    const [hoverText, setHoverText] = useState<string | undefined>(undefined);

    useEffect(() => {
        if (!preventDefaultTooltip){
            setHoverText(contentRef.current?.textContent ?? '');
        }
        else {
            setHoverText(undefined);
        }
    }, [children, preventDefaultTooltip]);
    
    useEffect(() => {
        if(!allowExpand){
            return;
        }
        function handleResize() {
            /*
            * The "true" height of the element is clipped by the overflow: hidden CSS property, but the DOM property scrollHeight will report the full height, while the clientHeight reports the rendered height. Though, has a small range of mistake.
            *
            * */
            const fullHeight = contentRef.current?.scrollHeight || 0;
            const renderedHeight = contentRef.current?.clientHeight || 0;
            setClamped(fullHeight > renderedHeight + 2);
        }
        handleResize();
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [allowExpand]);
    
    let style: React.CSSProperties = {};
    let className = '';
    
    if(maxWidth && !isExpanded){
        style.maxWidth = maxWidth.value + maxWidth.type;
    }
    if(maxLines && !isExpanded){
        className += ' line-clamp';
        style.WebkitLineClamp = maxLines;
    }
    
    return (
        <div className={'text-truncate'+ (isExpanded ? ' is-expanded' : ' is-collapsed')}>
            <div className={className} ref={contentRef} style={style} title={hoverText}>
                {children}
            </div>
            { isClamped && allowExpand && (
                <span
                    className="see-more"
                    onClick={() => setExpanded(!isExpanded)}
                >
                    { !isExpanded ? "see more" : "see less" }
                </span>
            )}
        </div>
    )
};

export default TextTruncate;
